import { ModuleWithProviders, NgModule } from '@angular/core';

import { PipesModule } from 'src/app/common/pipes/pipes.module';
import { SharedModule } from 'src/app/shared.module';
import { ViewsModule } from 'src/app/views/views.module';
import { CellDateComponent } from './components/cell-date/cell-date.component';
import { CellLinkComponent } from './components/cell-link/cell-link.component';
import { CellManageComponent } from './components/cell-manage/cell-manage.component';
import { CellManageRelationComponent } from './components/cell-manege-relation/cell-manage-relation.component';
import { CellRemoveComponent } from './components/cell-remove/cell-remove.component';
import { CellTextComponent } from './components/cell-text/cell-text.component';
import { CellUserBasicComponent } from './components/cell-user-basic/cell-user-basic.component';
import { CellUserInfoComponent } from './components/cell-user-info/cell-user-info.component';
import { TableCellFactory } from './directive/table-cell.factory';
import { TableConstructorComponent } from './table-constructor/table-constructor.component';

@NgModule({
  imports: [SharedModule, PipesModule, ViewsModule],
  declarations: [
    TableConstructorComponent,
    CellTextComponent,
    CellLinkComponent,
    CellDateComponent,
    CellManageComponent,
    CellRemoveComponent,
    CellUserBasicComponent,
    CellUserInfoComponent,
    CellManageRelationComponent,
  ],
  exports: [TableConstructorComponent],
})
export class TableConstructorModule {
  public static forRoot(): ModuleWithProviders<TableConstructorModule> {
    return {
      ngModule: TableConstructorModule,
      providers: [TableCellFactory],
    };
  }
}
